import { Star, Quote } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { TESTIMONIALS, REVIEW_STATS } from "@/data/content";

export const Testimonials = () => (
  <section data-testid="testimonials" className="bg-cream-200 py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-teal mb-4">Words of Hope</p>
          <h2 className="font-heading text-4xl md:text-6xl text-maroon-deep leading-[1.05] max-w-xl">
            Real stories from those we've walked beside
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="flex items-center gap-4 bg-white rounded-2xl px-6 py-4 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-stone-100">
            <span className="font-heading text-5xl text-sunrise leading-none">{REVIEW_STATS.rating}</span>
            <div>
              <div className="flex gap-0.5 mb-1">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={16} className="fill-gold text-gold" />
                ))}
              </div>
              <p className="text-xs text-stone-500">{REVIEW_STATS.count}+ {REVIEW_STATS.source}</p>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={(i % 3) * 0.1}>
            <div data-testid={`testimonial-${i}`} className="group bg-white rounded-2xl p-8 h-full shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-stone-100 transition-shadow duration-300 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] flex flex-col">
              <Quote size={28} className="text-sunrise/40 mb-4" />
              <p className="text-stone-600 leading-relaxed flex-1">{t.text}</p>
              <div className="mt-6 pt-5 border-t border-stone-100 flex items-center justify-between">
                <div>
                  <p className="font-heading text-xl text-maroon-deep">{t.name}</p>
                  <div className="flex gap-0.5 mt-1">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} size={12} className="fill-gold text-gold" />
                    ))}
                  </div>
                </div>
                <span className="text-[10px] uppercase tracking-wider text-teal bg-teal/10 px-3 py-1 rounded-full">{t.tag}</span>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
